import React from "react";
import OrnamentalDivider from "./OrnamentalDivider";

const QUOTES = [
    { en: "Listening to music is an art; experiencing it is meditation.", kn: "ಸಂಗೀತ ಕೇಳುವುದು ಕಲೆ, ಅನುಭವಿಸುವುದು ಧ್ಯಾನ." },
    { en: "Nada is Divine, Music is Sadhana.", kn: "ನಾದವೇ ದೈವ, ಸಂಗೀತವೇ ಸಾಧನೆ." },
    { en: "Where music flourishes, humanity blossoms.", kn: "ಸಂಗೀತ ಬೆಳಗಿದರೆ, ಮಾನವತೆಯೂ ಅರಳುತ್ತದೆ." },
];

export default function Anthem() {
    return (
        <section
            id="anthem"
            data-testid="anthem-section"
            className="section-pad bg-ivory"
        >
            <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
                <div className="eyebrow">· Gurukula Anthem ·</div>
                <h2 className="font-display text-4xl sm:text-5xl text-maroon mt-4 leading-tight">
                    Come to Shri Vishwa Bandhu Sangeetha Gurukula,
                    <span className="italic text-gold block mt-2">
                        let us light the lamp of music in every home.
                    </span>
                </h2>

                <div className="mt-10 font-serif text-xl lg:text-2xl text-ink/80 leading-loose italic">
                    <p>
                        Let us cleanse the mind and illuminate wisdom,
                        <br />
                        spreading the fragrance of culture wherever we go.
                    </p>
                </div>

                <OrnamentalDivider className="my-14" />

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="inspirational-quotes">
                    {QUOTES.map((q, i) => (
                        <blockquote
                            key={i}
                            className="bg-cream border border-gold-100 p-8 text-left"
                        >
                            <span className="font-display text-5xl text-gold leading-none block">
                                “
                            </span>
                            <p className="font-display italic text-xl text-maroon mt-2 leading-snug">
                                {q.en}
                            </p>
                            <p className="text-kannada text-lg text-ink/85 mt-4 leading-relaxed">
                                {q.kn}
                            </p>
                        </blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
}
